import React, { useCallback, useRef, useState } from 'react';
import { TableProps } from 'antd/lib/table';

export enum SortType {
    // 升序
    asce = 1,
    // 降序
    desc = 2,
    // 默认
    default = 3
}

type SortValue = React.Key;

type onTableChange = TableProps<any>['onChange'];

interface SortConfig {
    ascend: SortValue;
    descend: SortValue;
    default?: SortValue;
}

interface SortState {
    orderField: string;
    orderType: SortValue;
}

interface SecondResult {
    setSortState: React.Dispatch<React.SetStateAction<SortState>>;
    onSorterChange: onTableChange;
}

const defaultSortConfig: SortConfig = {
    ascend: SortType.asce,
    descend: SortType.desc,
    default: SortType.default
};

function useSorter(defaultField: string, config = defaultSortConfig): [SortState, SecondResult] {

    const [sortState, setSortState] = useState({
        orderField: defaultField,
        orderType: config.default!
    });

    const configRef = useRef(config);
    configRef.current = config;

    const onSorterChange = useCallback((pagination, filters, sorter, extra) => {
        const { field, order } = sorter;
        let orderType = configRef.current.default!;
        if (!!order) {
            orderType = configRef.current[order];
        }
        setSortState(v => ({
            orderField: field || v.orderField,
            orderType
        }));
    }, []);

    return [sortState, { setSortState, onSorterChange }];
}

export default useSorter;